export default __webpack_public_path__ + "static/media/MacroEconomy.f0b03f6d.svg";